<div id="section-colors" class="container">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Colors</p>

    <div class="row">
      <div class="col-md-3">
        <p class="h3 m-t-12">Primary</p>

        <div class="row m-t--12">
          <div class="col-md-12 m-t-12">
            <div class="p-12 border-card bg-primary text-white">.bg-primary</div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <p class="h3 m-t-12">Secondary</p>

        <div class="row m-t--12">
          <div class="col-md-12 m-t-12">
            <div class="p-12 border-card bg-secondary text-white">.bg-secondary</div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <p class="h3 m-t-12">Secondary 1</p>

        <div class="row m-t--12">
          <div class="col-md-12 m-t-12">
            <div class="p-12 border-card bg-secondary-1 text-white">.bg-secondary-1</div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <p class="h3 m-t-12">Secondary 2</p>

        <div class="row m-t--12">
          <div class="col-md-12 m-t-12">
            <div class="p-12 border-card bg-secondary-2">.bg-secondary-2</div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <p class="h3 m-t-12">Accent 1</p>

        <div class="row m-t--12">
          <div class="col-md-12 m-t-12">
            <div class="p-12 border-card bg-accent-1">.bg-accent-1</div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <p class="h3 m-t-12">Accent 2</p>

        <div class="row m-t--12">
          <div class="col-md-12 m-t-12">
            <div class="p-12 border-card bg-accent-2">.bg-accent-2</div>
          </div>
        </div>
      </div>
    </div>

    <p class="h3 m-t-12">Utils</p>

    <div class="row m-t--12">
      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-success text-white">.bg-success</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-danger text-white">.bg-danger</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-warning text-white">.bg-warning</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-info text-white">.bg-info</div>
      </div>
    </div>

    <p class="h3 m-t-12">Grays</p>

    <div class="row m-t--12">
      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-white text-dark">.bg-white</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-gray-100 text-dark">.bg-gray-100</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-gray-200 text-dark">.bg-gray-200</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-gray-300 text-dak">.bg-gray-300</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-gray-400 text-white">.bg-gray-400</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-gray-500 text-white">.bg-gray-500</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-gray-600 text-white">.bg-gray-600</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-gray-700 text-white">.bg-gray-700</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-gray-800 text-white">.bg-gray-800</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-gray-900 text-white">.bg-gray-900</div>
      </div>

      <div class="col-12 col-md-3 m-t-12">
        <div class="p-12 border-card bg-black text-white">.bg-black</div>
      </div>
    </div>
  </div>
</div>
